import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";

export function Draggable(props: any) {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: props.id,
  });
  const style = transform
    ? {
        transform: CSS.Translate.toString(transform),
      }
    : undefined;

  //   console.log(props.id);
  //   console.log("dragId", props.dragId, "test");
  //   ??

  return (
    <div style={{ position: "relative" }}>
      <button ref={setNodeRef} style={style} {...listeners} {...attributes}>
        {props.children}
      </button>
      {/* {props.dragId && (
        <button>
          <div className="absolute top-0 left-0 h-full w-full">
            {props.children}
          </div>
        </button>
      )} */}
    </div>
  );
}
